
export class AppUtility {

    public static isEmptyString(value: string): boolean {
        return value === null || value === undefined || value.trim() === '';
    }

    public static showEncryptedID(value: any): string {
        return (value === null || value === undefined || value.trim() === '') ? 'N/A' : '*****' + value.slice(-4);
    }

    public static formatValue(value: string): string {
        return (value === null || value === undefined || value.trim() === '') ? 'N/A' : value;
    }

    public static showDocumentName(value): string {
        if (value === 'nationalId') {
          return 'National Id';
        } else if (value === 'dl') {
          return 'Driving License';
        } else if (value === 'passport') {
          return 'Passport';
        } else {
          return value;
        }
      }

}
